export default class Header {

    constructor($view) {
        this.$view = $view;
        this.$myShop = $view.find('.my-shop');
        this.$myShopInfo = $view.find('.my-shop-info');
        this.bind();

    }

    bind() {
        let self = this;
        this.$myShop.on("click", function (e) {
            e.preventDefault();
            if(window.screen.width > 850){
                self.$myShopInfo.show();
            }
        });
        this.$myShopInfo.on("mouseleave", function () {
            self.closeTimeout = setTimeout(function () {
                self.$myShopInfo.hide();
            }, 400);
        });
        this.$myShopInfo.on("mouseenter", function () {
            clearTimeout(self.closeTimeout);
        });
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/Header.js